import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTag,
  faClock,
  faFireAlt,
  faLocationDot,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FaRegMessage } from "react-icons/fa6";
import { FaRegThumbsUp } from "react-icons/fa";
import { getDetails } from "../../services/news";
import { useLocation } from "react-router-dom";

const admin_type = localStorage.getItem("admin_type") || ""; // Get admin type

const ViewNews = () => {
  const [newsDetail, setNewsDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchNewsDetails = async () => {
      try {
        setLoading(true);
        // Extract news_id from URL hash
        const searchParams = new URLSearchParams(location.search);
        // const newsId = searchParams.get("news_id");

        const newsId = location.pathname.split("/").pop();

        if (!newsId) {
          console.error("News ID not found in URL");
          setLoading(false);
          return;
        }

        // Call the actual API
        const response = await getDetails(newsId);

        if (response.data && response.data.result) {
          // Set the newsDetail from the response structure
          setNewsDetail(response.data.result);
        } else {
          console.error("Invalid response structure:", response);
        }
      } catch (error) {
        console.error("Error fetching news details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsDetails();
  }, [location]);

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!newsDetail) {
    return <div className="text-center mt-5">News not found</div>;
  }

  // Convert tags from string to array if needed
  const tagsList = newsDetail.tags
    ? Array.isArray(newsDetail.tags)
      ? newsDetail.tags
      : typeof newsDetail.tags === "string"
      ? newsDetail.tags.split(",").map((t) => t.trim()).filter(Boolean)
      : []
    : [];

  return (
    <div
      className={`view-news ${
        admin_type === "sub_admin" ? "subAdminNews" : ""
      }`}
    >
      {/* Header section */}
      <div className="newsDetails">
        <div>
          <h1>News &gt; {newsDetail.title}</h1>
        </div>
        <div>
          <Button className="border border-white text-white bg-transparent buttons share-btn">
            Share News
          </Button>
        </div>
      </div>

      {/* Cover Image */}
      <div className="h-screen bg-gray-900 mt-5 flex items-center justify-center ">
        <div className="p-2 rounded-lg mainDiv shadow-lg cover-img">
          <img
            src={newsDetail.cover_image}
            alt="Cover-Image"
            className="coverImageNews"
          />
        </div>
      </div>

      {/* Title and Author */}
      <div className="mt-4">
        <div className="textHeading">
          <p className="AllText">{newsDetail.title}</p>
          <div className="headingText">
            <div className="authorImage">
              <img
                className="imageWidthAuthor"
                src={newsDetail.author_image}
                alt="Author Image"
              />
              <div>
                <p className="authorName">{newsDetail.author_name}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Category and Tags */}
      <div className="news-meta-info mt-4 mb-4">
        <div className="d-flex align-items-center flex-wrap gap-2">
          <span className="news-category me-2">
            {newsDetail.category_name || newsDetail.category}
          </span>
          {newsDetail.is_popular === "1" && (
            <span className="news-popular-badge me-2">
              <FontAwesomeIcon icon={faFireAlt} className="me-1" />
              Popular
            </span>
          )}
          {newsDetail.is_featured === "1" && (
            <span
              className="news-featured-badge me-2"
              style={{
                backgroundColor: "#7367f0",
                color: "white",
                padding: "0.25rem 0.75rem",
                borderRadius: "30px",
                fontSize: "0.85rem",
                fontWeight: "500",
              }}
            >
              <FontAwesomeIcon icon={faStar} className="me-1" />
              Featured
            </span>
          )}
          <span className="news-time-badge">
            <FontAwesomeIcon icon={faClock} className="me-1" />
            {newsDetail.time_taken}
          </span>
        </div>

        <div className="news-tags mt-2">
          <FontAwesomeIcon icon={faTag} className="me-2" />
          {tagsList.map((tag, index) => (
            <span key={index} className="tagItem">
              {tag.trim()}
              {index < tagsList.length - 1 && ", "}
            </span>
          ))}
        </div>
      </div>

      {/* News Content */}
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: newsDetail.description,
          }}
          className="newsDescription"
        ></div>
      </div>
    </div>
  );
};

export default ViewNews;
